import React, {Component} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import MCEadContentsList from "../../../../../../../../components/_ead/ContentsList/index"
import FileRequests from '../../../../../../../../requests/file-requests'
import FileSaver from 'file-saver'
import {getFromS3} from '../../../../../../../../helpers/aws'
import NRTFormInput from "../../../../../../../../components/_common/_form/FormInput/index"


const SIMULATE_GET_CONTENTS_ERROR = false

class EadCouseContents extends Component {

    state = {
        awaiting: true,
        file: [],
        selectedRadio: 'alphabetic',
        loadingDownload: false,
        notContents: false,
        loadingContents: true,
        callId: 0
    }


    async componentDidMount() {
        const {release} = this.props;

        const req = SIMULATE_GET_CONTENTS_ERROR ?
            Promise.reject('SIMULATE_GET_CONTENTS_ERROR') :
            FileRequests
                .search({
                    entityClass: "br.com.nerit.entity.model.EmpProductRelease",
                    entityCode: release.code,
                    category: 3,
                    fileType: 3
                })

        req
            .then(result => {
                if (result.file.length != 0) {
                    this.setState({
                        file: result.file.sort((a, b) => a.title.localeCompare(b.title)),
                        loadingContents: false
                    })
                }else{
                    this.setState({
                        notContents: true,
                        loadingContents: false
                    })
                }

            })
            .catch(error => {

                this.props.context.set({
                    toastMessage: {
                        type:'error',
                        content: 'Ocorreu um erro inesperado.'
                    }
                })
                this.props.context.logError(JSON.stringify(error))
            })


    }


    onSortChanged = _.debounce((name, value) => {

        if (this.state.selectedRadio === value)
            return

        let array = []

        const file = [...this.state.file]

        switch (value) {
            default:
            case 'alphabetic':
                array = file.sort((a, b) => a.title.localeCompare(b.title));
                break
            case 'recentes':
                array = file.sort((a, b) => b.date - a.date)
                break
            case 'antigas':
                array = file.sort((a, b) => a.date - b.date)
                break

        }

        this.setState({
            selectedRadio: value,
            file: array
        })

    }, 300)


    onContentClick = (path, title, callId) => {
        this.setState({
            callId: callId,
            loadingDownload: true
        }, () => {
            getFromS3(path, title)
            .then((data) => {
                FileSaver.saveAs(new Blob([data.Body], {type: "octet-scream"}), `${title}`)
                this.setState({
                    loadingDownload: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
        })
    }

    
    render() {



        return (
            <div style={{width: '100%'}}>


                <NRTFormInput
                    label={'Ordenar por'}
                    onChange={this.onSortChanged}
                    value={this.state.selectedRadio}
                    type={'radiogroup'}

                    style={{
                        justifyContent: 'flex-start',

                    }}
                    customProps={{
                        options: [
                            {
                                value: 'alphabetic',
                                display: 'Ordem Alfabética'
                            },
                            {
                                value: 'recentes',
                                display: 'Mais recentes'

                            },
                            {
                                value: 'antigas',
                                display: 'Mais antigos'

                            }
                        ],
                        style: {
                            justifyContent: 'center',
                            display: 'flex',
                        }
                    }}
                />


                <MCEadContentsList
                    callId={this.state.callId}
                    loadingDownload={this.state.loadingDownload}
                    loadingContents={this.state.loadingContents}
                    notContents={this.state.notContents}
                    onContentClick={this.onContentClick}
                    contents={this.state.file}
                />
            </div>
        )
    }
}


EadCouseContents.propTypes = {
    context: PropTypes.object.isRequired,
}
EadCouseContents.defaultProps = {}

export default EadCouseContents



// WEBPACK FOOTER //
// ./src/_pages/Account/_pages/CourseList/_pages/Course/_partials/Contents/index.js